import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "subGroupClose",
  "use": "subGroupClose-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"subGroupClose\">\n<path d=\"M7.83095 4.49582L7.92103 4.61226H8.06824H12.9394C13.3382 4.61743 13.7 4.97857 13.7 5.47479V11.8375C13.7 12.3337 13.3382 12.6949 12.9394 12.7H3.06059C2.66185 12.6949 2.29998 12.3337 2.3 11.8375L2.3 4.1639L2.3 4.16358C2.29947 3.66694 2.66151 3.30526 3.06059 3.30008H6.90592L7.83095 4.49582Z\" fill=\"#FAF9F8\" stroke=\"#005A9E\" stroke-width=\"0.6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol